import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {MediaMatcher} from '@angular/cdk/layout';

@Component({
  selector: 'app-postlogin-layout',
  templateUrl: './postlogin-layout.component.html',
  styleUrls: ['./postlogin-layout.component.css']
})
export class PostloginLayoutComponent implements OnInit, OnDestroy {

  public innerWidth: any;
  backdrop:boolean=false
  @HostListener("window:resize", []) updateDays() {
    if (window.innerWidth <= 575.98) {
      this.backdrop = true; 
    } else {
      this.backdrop = false;
    }
  }
  merchantDetails:any;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  sidenavCloseArray=[
    "/templates/add","/edit-profile", "/help-support"
  ];
  closeSidenav:boolean = false;
  featuresWhitelisted = "";
  @ViewChild('sidenav') sidenav;

  constructor( private router: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher ) {
    this.merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'));
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe((ev:any) => {
      if (ev instanceof NavigationEnd) { 
        this.checkRouteURl(ev.url);
      }
    });
   }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    if(this.innerWidth<= 575.98) {
      this.backdrop = true; // lg
    } else {
      this.backdrop = false;//xs
    }
    this.featuresWhitelisted = localStorage.getItem('Features-Whitelisted')
  }

  toggleSideNav() {
    this.sidenav.toggle();
  }

  checkRouteURl(url){
    let a = url.split('?');
    if(this.sidenavCloseArray.includes(a[0])){
      this.closeSidenav = true;
    }else{
      this.closeSidenav = false;
    }
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/signin');
  }
}
